export const STEPS = {
  SERVICE: 0,
  ADDRESS: 1,
  TIMESLOT: 2,
  CONTACT: 3,
};

export const SERVICE_TYPE = {
  OMBORI: "OMBORI",
  IKEA: "IKEA",
};
